import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSetupAuditTrailSourceNamePrefixSlice } from './get';

export const coreSetupAuditTrailSourceNamePrefixReducers = combineReducers({
	get: getCoreSetupAuditTrailSourceNamePrefixSlice.asyncReducers
});

export const coreSetupAuditTrailSourceNamePrefixWatchers = combineAllWatchers([
	getCoreSetupAuditTrailSourceNamePrefixSlice.asyncWatchers
]);
